module.exports = {"data":{"contentfulMember":{"name":"Steinar Andreassen","designation":"Co-Founder","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/6DCDGDAXf2QoCquYEkGWeU/1a64ea76e0bddee88ff5419ffb7cd668/Steinar.jpg"}},"content":{"content":"![blogMSA002A](//images.contentful.com/1o5ly3na7qu2/2D9fZow1zmG06uEAYmEmY4/159c920928728713b1902eb546d9ccac/blogMSA002A.JPG)\n\n__Steinar Andreassen__\n- MSA Co-Founder\n- Amateur astronomer, astrophotographer"}}},"pathContext":{"id":"c9vPxNqplKM2SeksmgSggC"}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/member-steinar-andreassen.json
// module id = 489
// module chunks = 21223537494785